import { createEditLayoutV2 } from "src/framework/editV2/createEditLayoutV2.tsx";
import { createCreateLayoutV2 } from "src/framework/createV2/createCreateLayoutV2.tsx";

export const createFormLayoutRoute = ({
  type,
  resource,
  layoutForm,
}: {
  resource: string;
  type: "create" | "edit";
  layoutForm?: boolean;
}) => {
  return type === "edit"
    ? createEditLayoutV2({
        layoutForm,
        resource,
      })
    : createCreateLayoutV2({
        layoutForm,
        resource,
      });
};
